import { useCallback } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createTextNode, $getSelection } from 'lexical';

/**
 * This hook is used to insert an empty space into the editor.
 * @returns A function that inserts an empty space into the editor.
 */

export const useEmptySpaceInsertion = () => {
  const [editor] = useLexicalComposerContext();

  const insertEmptySpace = useCallback(() => {
    editor.update(() => {
      const selection = $getSelection();

      if (selection !== null) {
        const space = $createTextNode(' ');
        selection.insertNodes([space]);
      }
    });
  }, [editor]);

  return insertEmptySpace;
};
